import { ENUM_STORAGE_WEBPACK_VERSION } from 'storage/storageActions';
import { isBrowser } from 'utils/helper';

export const setStorageWebpackVersion = hash => {
	if(isBrowser) {
		sessionStorage.setItem(ENUM_STORAGE_WEBPACK_VERSION, hash);
	}
};
